import { uniProfession } from "./Profession";
import { DAO } from "./DAO";
import { useAppContext } from "../../libs/app-core/AppContext";
import { useEffect, useState } from "react";
import { OnApiError } from "../ErrorManager";
import { ApiResult, API } from "./API";
import { WS_Public } from "./WS";

export class ProfessionDAO {

  static async Select(): Promise<uniProfession[]> {
    let cond = " WHERE (1=1) ";
    let data_list = await DAO.Select(uniProfession, cond);
    return data_list;
  }
  static async SelectAll(is_desc: boolean): Promise<uniProfession[]> {
    let cond = " WHERE (1=1) "
      + Cnd.OrderBy_RecDT_Code(is_desc);

    let data_list = await DAO.Select(uniProfession, cond);

    return data_list;
  }

  static async FetchByGuid(guid: string): Promise<uniProfession> {
    let data = await DAO.FetchByGuid(uniProfession, guid);
    return data;
  }

  static async Insert(data: uniProfession): Promise<uniProfession> {
    let refetch_data = await DAO.Insert(uniProfession, data);
    return refetch_data;
  }

  static async Update(data: uniProfession): Promise<uniProfession> {
    let refetch_data = await DAO.Update(uniProfession, data);
    return refetch_data;
  }

  static async Delete(data: uniProfession): Promise<number> {
    let effect_rows_cnt = await DAO.DeleteByGuid(uniProfession, data.guid);
    return effect_rows_cnt;
  }
  static async WS_SelectAllProfession(): Promise<uniProfession[] | undefined> {
    let api_rslt: ApiResult = await WS_Public.CallPublicGet(
      "profession/select_all",
      undefined
    );
    if (api_rslt.code === API.CODE_OK) {
      let project_list = API.ToClassList(uniProfession, api_rslt.data);
      return project_list;
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }
}

export function useProfessionList(is_desc: boolean) {
  const ctx = useAppContext();

  const [_ProfessionList, set_ProfessionList] = useState<uniProfession[] | undefined>(undefined);// 尚未撈資料庫時為 undefined

  async function refresh_ProfessionList() {
    try {
      const data_list = await ProfessionDAO.SelectAll(is_desc);

      set_ProfessionList(data_list);

    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_ProfessionList();
  }, [is_desc]);

  return { _ProfessionList, set_ProfessionList, refresh_ProfessionList }
}

class Cnd {
  static 指定idpw(emp_id: string, emp_pw: string) {
    return ` (emp_id='${emp_id}' AND emp_pw='${emp_pw}') `;
  }
  static OrderBy_RecDT_Code(is_desc: boolean) {
    if (is_desc) {
      return " ORDER BY serno DESC ";
    } else {
      return " ORDER BY serno ";
    }
  }
}